import { FOLLOW_UP_QUESTIONS } from './describe.strings';
import type {
  DescribeAction,
  DescribeState,
  DescribeStepKey,
} from '../types/describe.types';

export const TOTAL_CORE_STEPS = 4;
export const TOTAL_STEPS = TOTAL_CORE_STEPS + FOLLOW_UP_QUESTIONS.length;

export function createInitialDescribeState(sessionId: string): DescribeState {
  return {
    sessionId,
    goal: null,
    outcome: null,
    date: null,
    people: null,
    followUps: [],
    currentStepIndex: 0,
    isComplete: false,
  };
}

export function describeReducer(
  state: DescribeState,
  action: DescribeAction
): DescribeState {
  switch (action.type) {
    case 'SUBMIT_GOAL':
      return advance({ ...state, goal: action.payload }, 0);
    case 'SUBMIT_OUTCOME':
      return advance({ ...state, outcome: action.payload }, 1);
    case 'SUBMIT_DATE':
      return advance({ ...state, date: action.payload }, 2);
    case 'CLEAR_DATE':
      return {
        ...state,
        date: null,
        people: null,
        followUps: [],
        currentStepIndex: 2,
        isComplete: false,
      };
    case 'SUBMIT_PEOPLE':
      return advance({ ...state, people: action.payload }, 3);
    case 'SUBMIT_FOLLOWUP': {
      const { index, answer } = action.payload;
      const question = FOLLOW_UP_QUESTIONS[index];
      if (!question) return state;

      const nextFollowUps = state.followUps.slice();
      nextFollowUps[index] = {
        id: `followup-${index}`,
        question,
        answer,
      };

      return advance(
        { ...state, followUps: nextFollowUps },
        TOTAL_CORE_STEPS + index
      );
    }
    case 'RESET':
      return createInitialDescribeState(state.sessionId);
    default:
      return state;
  }
}

function advance(
  state: DescribeState,
  submittedStepIndex: number
): DescribeState {
  const nextIndex = submittedStepIndex + 1;
  const isComplete = nextIndex >= TOTAL_STEPS;
  return {
    ...state,
    currentStepIndex: isComplete ? TOTAL_STEPS : nextIndex,
    isComplete,
  };
}

export function getStepKey(stepIndex: number): DescribeStepKey {
  if (stepIndex === 0) return 'goal';
  if (stepIndex === 1) return 'outcome';
  if (stepIndex === 2) return 'date';
  if (stepIndex === 3) return 'people';
  if (stepIndex >= TOTAL_STEPS) return 'complete';
  return `followup-${stepIndex - TOTAL_CORE_STEPS}`;
}
